import { useEffect } from "react";
import api from "@/lib/api";
import { applyAccentColor } from "@/lib/theme";

// Runs once when the app loads: asks the backend for the saved accent
// color and applies it everywhere. If it can't be read for any reason
// (not logged in yet, network hiccup), the page just keeps the default
// orange already baked into index.css — nothing breaks.
export default function ThemeProvider({ children }) {
  useEffect(() => {
    let cancelled = false;

    async function loadAccentColor() {
      try {
        const { data } = await api.get("/settings/appearance");
        if (!cancelled && data?.accent_color) {
          applyAccentColor(data.accent_color);
        }
      } catch (e) {
        /* keep default accent */
      }
    }

    loadAccentColor();

    return () => {
      cancelled = true;
    };
  }, []);

  return children;
}
